module.exports = __webpack_public_path__ + "static/media/Anonymous Reporting Protocol JayDoc Free Clinic.b33850cd.pdf";